import { MatchOfficial, MatchOfficials } from "../matchTypes";

export const OFFICIAL_FIELDS: { key: keyof MatchOfficials; label: string }[] = [
  { key: "umpire", label: "Umpire" },
  { key: "squareLegUmpire", label: "Square-Leg Umpire" },
  { key: "scorer", label: "Scorer" },
  { key: "matchReferee", label: "Match Referee" },
];

export function isAssigned(official: MatchOfficial | null | undefined): boolean {
  return !!official && typeof official.name === "string" && official.name.trim().length > 0;
}

export interface AssignedOfficial {
  key: keyof MatchOfficials;
  label: string;
  official: MatchOfficial;
}

export function assignedOfficials(
  officials: MatchOfficials | null | undefined
): AssignedOfficial[] {
  if (!officials) return [];
  const result: AssignedOfficial[] = [];
  for (const field of OFFICIAL_FIELDS) {
    const official = officials[field.key];
    if (isAssigned(official)) {
      result.push({ key: field.key, label: field.label, official: official as MatchOfficial });
    }
  }
  return result;
}

export function hasAnyOfficial(officials: MatchOfficials | null | undefined): boolean {
  return assignedOfficials(officials).length > 0;
}

// Build a stored official from a name plus an optional linked profile.
// Returns null when the name is blank so callers can treat "empty" as "unassigned".
export function makeOfficial(
  name: string,
  profileId?: string | null,
  photoUrl?: string | null
): MatchOfficial | null {
  const trimmed = (name || "").trim();
  if (!trimmed) return null;
  return {
    name: trimmed,
    profileId: profileId ?? null,
    photoUrl: photoUrl ?? null,
  };
}

// Immutably assign or clear a single official field.
export function setOfficial(
  officials: MatchOfficials | null | undefined,
  key: keyof MatchOfficials,
  official: MatchOfficial | null
): MatchOfficials {
  const next: MatchOfficials = { ...(officials || {}) };
  if (official) {
    next[key] = official;
  } else {
    delete next[key];
  }
  return next;
}
